import React, { useState, useEffect } from 'react'
import TopNavigation from '../../layouts/top-navigation/TopNavigation'
import JobSidebar from '../../components/JobSidebar'
import JobActive from './JobActive';
import JobClosed from './JobClosed'

import { useAppDispatch, useAppSelector } from '../../useStore';
import { getalljobs, reset } from '../../features/Job/jobSlice';
import moment from 'moment';
import BottomNavigation from '../../layouts/bottom-navigation/BottomNavigation';



const Jobs = () => {
	const { data: datas, isError, isLoading, message, isSuccess } = useAppSelector((state: any) => state.job);
	const date = moment().startOf('day');
	const dispatch = useAppDispatch();


	const [active, setActive] = useState<number>(1)
	const [jobLenght, setJobLenght] = useState<any>(0)
	const [closedJob, setClosedJob] = useState<any>(0)



	const result = datas?.data?.reduce((acc, obj) => {
		const expiryDate = moment(obj?.expiryDate).startOf('day');
		if (expiryDate.isSameOrAfter(date)) {
			acc?.active?.push(obj);
		} else {
			acc?.dropout?.push(obj);
		}
		return acc;
	}, { active: [], dropout: [] });

	const actives = result?.active;
	const dropout = result?.dropout;





	useEffect(() => {
		dispatch(getalljobs());
	}, [dispatch]);



	return (
		<div id="screen-wrapper">
			<TopNavigation />
			<BottomNavigation />
			<JobSidebar setActive={setActive} data={actives} jobLenght={jobLenght} closedJob={closedJob} active={actives} dropout={dropout} />
			<main>
				{active === 1 && <JobActive setActive={setActive} setJobLenght={setJobLenght} data={actives} isLoading={isLoading} message={message} isError={isError} />}
				{active === 2 && <JobClosed setClosedJob={setClosedJob} data={dropout} isLoading={isLoading} message={message} isError={isError} />}
			</main>
		</div>
	)
}

export default Jobs